import Pill from '@components/V3/Pill'

function WebsiteCoinsSkeleton() {
  return <Pill showCaret={false} className="h-12 w-12 lg:w-32 animate-pulse" />
}

export default WebsiteCoinsSkeleton
